if (!customElements.get("video-gallery-component")) {
  customElements.define(
    "video-gallery-component",
    class VideoGalleryComponent extends HTMLElement {
      connectedCallback() {
        this.dialogComponent = this.querySelector("dialog-component");
        this.player = this.querySelector("[data-vg-player]");
        this.dialogEl = this.dialogComponent?.querySelector("dialog");

        this.onTriggerClick = this.onTriggerClick.bind(this);
        this.stopPlayback = this.stopPlayback.bind(this);

        this.addEventListener("click", this.onTriggerClick);

        if (this.dialogComponent && !this.dialogComponent.__vgPatched) {
          const originalClose = this.dialogComponent.closeDialog.bind(this.dialogComponent);
          this.dialogComponent.closeDialog = async () => {
            this.stopPlayback();
            return originalClose();
          };
          this.dialogComponent.__vgPatched = true;
        }

        this.dialogEl?.addEventListener("close", this.stopPlayback);
      }

      disconnectedCallback() {
        this.removeEventListener("click", this.onTriggerClick);
        this.dialogEl?.removeEventListener("close", this.stopPlayback);
        this.stopPlayback();
      }

      onTriggerClick(event) {
        const trigger = event.target.closest("[data-vg-src]");
        if (!trigger || !this.contains(trigger) || trigger.disabled) return;

        event.preventDefault();
        this.openVideo(trigger);
      }

      openVideo(trigger) {
        if (!this.dialogComponent || !this.player) return;

        const type = trigger.dataset.vgType;
        const src = trigger.dataset.vgSrc;
        const ratio = trigger.dataset.vgRatio || "16 / 9";
        const parts = ratio.split("/").map((value) => parseFloat(value));
        const ratioW = parts[0] || 16;
        const ratioH = parts[1] || 9;
        const cssRatio = `${ratioW} / ${ratioH}`;

        this.stopPlayback();
        this.player.style.setProperty("--vg-modal-ratio", cssRatio);
        this.dialogEl?.style.setProperty("--vg-modal-ratio", cssRatio);
        this.dialogEl?.style.setProperty(
          "--dialog-max-width",
          `min(92vw, calc(85vh * ${ratioW} / ${ratioH}))`
        );

        if (type === "youtube" || type === "vimeo") {
          const iframe = document.createElement("iframe");
          iframe.src = src;
          iframe.setAttribute("allow", "autoplay; encrypted-media; picture-in-picture; fullscreen");
          iframe.setAttribute("allowfullscreen", "");
          iframe.setAttribute("title", trigger.getAttribute("aria-label") || "Video");
          iframe.setAttribute("referrerpolicy", "strict-origin-when-cross-origin");
          this.player.appendChild(iframe);
        } else {
          const video = document.createElement("video");
          video.src = src;
          video.controls = true;
          video.autoplay = true;
          video.playsInline = true;
          video.setAttribute("playsinline", "");
          video.setAttribute("webkit-playsinline", "");
          this.player.appendChild(video);
          video.play().catch(() => {});
        }

        this.dialogComponent.showDialog();
      }

      stopPlayback() {
        if (!this.player) return;

        this.player.querySelectorAll("video").forEach((video) => {
          video.pause();
          video.removeAttribute("src");
          video.load();
        });
        this.player.querySelectorAll("iframe").forEach((iframe) => {
          iframe.src = "about:blank";
        });
        this.player.replaceChildren();
      }
    }
  );
}
